
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estandares-de-conducta",
      function () {
        return require("private-next-pages/estandares-de-conducta/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estandares-de-conducta"])
      });
    }
  